export default (str = '', count) => (count > 1 ? `${str}s` : str);
